import { HirerTeamMemberJobAccessProvider } from '@seek/hirer-team-member-job-access';
import { useTranslations } from '@vocab/react';
import { Box, Dialog, useToast } from 'braid-design-system';
import { observer } from 'mobx-react';
import type { FC } from 'react';

import hirerGraphClient from 'src/graphql/hirer/client';
import { useStores } from 'src/utils/hooks/useStores';

import translations from './.vocab';
import { TeamMemberAccess } from './TeamMemberAccess';

interface TeamAccessDialogProps {
  open: boolean;
  onClose: () => void;
}

export const TeamAccessModal: FC<TeamAccessDialogProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslations(translations);
  const showToast = useToast();
  const {
    userStore: { user },
    seekAdvertiserId,
    jobId,
    jobStore: { job },
  } = useStores();

  const handleSaveSuccess = () => {
    onClose();
    showToast({
      tone: 'positive',
      message: t('Team access updated'),
      closeLabel: t('Close'),
    });
  };

  return (
    <Dialog
      id="team-access-dialog"
      open={open}
      onClose={onClose}
      width="medium"
      title={t('Give access to your team and invite them to this job ad')}
    >
      <Box
        width="full"
        height="full"
        style={{ maxHeight: 'calc(100vh - 300px)' }}
        overflow="auto"
      >
        <HirerTeamMemberJobAccessProvider
          jobId={jobId.toString()}
          seekAdvertiserId={seekAdvertiserId}
          currentLoginUserId={user.userId?.toString() || ''}
          apolloClient={hirerGraphClient}
        >
          <TeamMemberAccess
            onSubmitSuccess={handleSaveSuccess}
            onCancel={onClose}
            jobTitle={job?.jobInformation?.title}
            jobId={jobId.toString()}
            userName={user.name}
          />
        </HirerTeamMemberJobAccessProvider>
      </Box>
    </Dialog>
  );
};
export default observer(TeamAccessModal);
